import { toValue } from 'vue'
import { defineStore } from 'pinia'

export const useSecureStore = defineStore('SecureStore', {
  state: () => ({
    procedure: {},
    loader: false,
    error: {}
  }),
  getters: {
    getProcedureSecureToken: state => ({ id }) => state.$getItem({
      resource: 'procedure',
      key: id,
      dependencies: [id],
      fetch: () => state.fetchProcedureSecureToken({ id })
    })
  },
  actions: {
    async fetchProcedureSecureToken ({ id }) {
      await this.$pipeline({ dependencies: [id] })

      return this.$fetchItem({
        endpoint: `/api/v1/secure/token/procedure/${toValue(id)}`,
        resource: `procedure.${toValue(id)}`
      })
    }
  }
})